<template>
  <b-container fluid>
    <page-title icon="fas fa-money-bill-alt">
      <translate>Transactions History</translate>
    </page-title>
    <transactions-history />
  </b-container>
</template>
<script>
import TransactionsHistory from '@/components/TransactionsHistory'

export default {
  name: 'TransactionsHistoryPage',
  title() {
    return this.$gettext('Transactions History')
  },
  components: {
    TransactionsHistory
  }
}
</script>
